/* eslint-disable @blumintinc/blumint/require-dynamic-firebase-imports */
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  connectAuthEmulator,
  indexedDBLocalPersistence,
} from 'firebase/auth';
import { detectPlatform } from '../../util/platform';
import { getApp } from './app';

const app = getApp();

// eslint-disable-next-line import/no-mutable-exports
let auth: ReturnType<typeof getAuth>;
const initializeAuth = async () => {
  if (!auth) {
    auth = getAuth(app);

    // Connect emulator after persistence is set
    if (process.env.NEXT_PUBLIC_EMULATOR_MODE === 'true') {
      auth.settings.appVerificationDisabledForTesting = true;
      connectAuthEmulator(auth, 'http://localhost:9099');
    }
    if (process.env.PLAYWRIGHT_TEST === 'true') {
      auth.settings.appVerificationDisabledForTesting = true;
    }

    // Set persistence first before any other operations
    await setPersistence(
      auth,
      detectPlatform() === 'browser'
        ? browserLocalPersistence
        : indexedDBLocalPersistence,
    );
  }
  return auth;
};

// Initialize auth immediately
initializeAuth().catch(console.error);

export { auth, initializeAuth };
